import { Route, Switch } from 'react-router'
import menuItems from 'config/MenuItems'
import routes from 'config/routes'
import SignOutPage from 'pages/Auth/SignOutPage'

const MainRouter = () => (
  <Switch>
    {menuItems.map(({ routeName, component }) => (
      <Route key={routeName} exact path={routeName} component={component} />
    ))}

    {routes.map(({ routeName, component }) => (
      <Route
        key={`${routeName}`}
        exact
        path={`${routeName}`}
        component={component}
      />
    ))}

    <Route exact path="/sign-out" component={SignOutPage} />
  </Switch>
)

export default MainRouter
